import { Apis } from '../../app.constants.js';
import APIService from '../../APIService.js';

type SmsActionsType = {
  createSms: (data: any) => Promise<any>;
  getSmsList: (data: any) => Promise<any>;
  sendSms: (data: any) => Promise<any>;
  updateSms: (data: any) => Promise<any>;
  getSmsLogs: (data: any) => Promise<any>;
  downloadSmsReport: (data: { start_date: string; end_date: string }) => Promise<any>;
};

const SmsActions = (): SmsActionsType => {

  const createSms = async (data: any): Promise<any> => {
    try {
      let res = await APIService.post(Apis.smsTemplate, data);
      return res;
    } catch (error) {
      console.error('Error posting SMS list:', error);
      throw new Error('Failed to post SMS list. Server responded with an error.');
    }
  };
  const getSmsList = async (data: any): Promise<any> => {
    try {
      const res = await APIService.get(`${Apis.smsTemplate}?page=${data?.page}&limit=${data?.limit}&search=${data?.search || ''}&status=${data?.status || ''}`)
      if (res?.status === 200) {
        return res
      } else {
        throw new Error('Failed to post SMS list. Server responded with an error.');
      }
    } catch (error) {
      console.error('Error posting SMS list:', error);
      throw error;
    }
  };

  const sendSms = async (data: any): Promise<any> => {
    try {
      const res = await APIService.post(`${Apis.smsSendTemplate}`, data)
      if (res?.status === 200) {
        return res
      } else {
        throw new Error('Failed to Send SMS. Server responded with an error.');
      }
    } catch (error) {
      console.error('Error sending SMS:', error);
      throw error;
    }
  };
  const updateSms = async (data: any): Promise<any> => {
    try {
      let res = await APIService.put(Apis.smsTemplate, data);
      return res;
    } catch (error) {
      console.error('Error posting SMS list:', error);
      throw new Error('Failed to update SMS. Server responded with an error.');
    }
  };

  const getSmsLogs = async (data: {
    start_date?: string;
    end_date?: string;
    phone?: string;
    page?: number;
    page_size?: number;
  }): Promise<any> => {
    try {
      const params = new URLSearchParams();
      if (data?.start_date) params.append('start_date', data.start_date);
      if (data?.end_date) params.append('end_date', data.end_date);
      if (data?.phone) params.append('phone', data.phone);
      if (data?.page) params.append('page', String(data.page));
      if (data?.page_size) params.append('page_size', String(data.page_size));

      const res = await APIService.get(`${Apis.smsReportView}?${params.toString()}`);
      if (res?.status === 200) {
        return res;
      } else {
        throw new Error('Failed to fetch SMS logs. Server responded with an error.');
      }
    } catch (error) {
      console.error('Error fetching SMS logs:', error);
      throw error;
    }
  };

  // const downloadSmsReport = async (data: {
  //   start_date: string;
  //   end_date: string;
  // }): Promise<any> => {
  //   try {
  //     const params = new URLSearchParams();
  //     params.append('start_date', data.start_date);
  //     params.append('end_date', data.end_date);

  //     const res = await APIService.get(
  //       `${Apis.smsReportDownload}?${params.toString()}`,
  //       { responseType: 'blob' } // important for file download
  //     );

  //     if (res?.status === 200) {
  //       return res;
  //     } else {
  //       throw new Error('Failed to download SMS report.');
  //     }
  //   } catch (error) {
  //     console.error('Error downloading SMS report:', error);
  //     throw error;
  //   }
  // };

  const downloadSmsReport = async (data: {
    start_date: string;
    end_date: string;
  }): Promise<any> => {
    try {
      const params = new URLSearchParams();
      params.append('start_date', data.start_date);
      params.append('end_date', data.end_date);

      return await APIService.downloadFile(
        `${Apis.smsReportDownload}?${params.toString()}`,
        'sms-report.xlsx'
      );
    } catch (error) {
      console.error('Error downloading SMS report:', error);
      throw error;
    }
  };

  return {
    createSms,
    updateSms,
    getSmsList,
    sendSms,
    getSmsLogs,
    downloadSmsReport,
  };
};

export { SmsActions };
